// extracted by mini-css-extract-plugin
export default {"innerWrapper":"pt-z","tooltipWrapper":"qt-z","icon":"rt-z","tooltip":"st-z","content":"tt-z"};